import React, { Component } from "react";
import ReactPlayer from "react-player";
import { Container, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";

class video {
  constructor(display, id) {
    this.display = display;
    this.id = id;
  }
  display;
  id;
}

export class FAQVideo extends Component {
  constructor(props) {
    super(props);
    this.state = { currentVideo: "40668464" };
  }

  url = "https://vimeo.com/";
  videos = [
    new video("Why an Orthodontist?", 40668464),
    new video("What to Eat While Wearing Braces", 40747848),
    new video(
      "Everyone Deserves Straight Teeth and a Beautiful Smile",
      40619467
    ),
    new video("Brushing and Flossing With Braces", 40747736),
    new video("Braces Are Far More Attractive Than Crooked Teeth", 40747918),
    new video("Braces Are Affordable and Convenient", 40669722)
  ];
  render() {
    return (
      <Container className="content">
        <Row>
          <Col>
            <h1>Frequently Asked Questions</h1>
          </Col>
        </Row>
        <Row>
          <Col>
            {this.videos.map(video => (
              <div>
                <a
                  href="javascript:void(0);"
                  onClick={() => this.setState({ currentVideo: video.id })}
                >
                  <FontAwesomeIcon icon={faQuestionCircle} /> {video.display}
                </a>
              </div>
            ))}
            <br />
          </Col>
          <Col>
            <ReactPlayer
              url={this.url + this.state.currentVideo}
              className="videoPlayer"
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <br />
            <br />
          </Col>
        </Row>
      </Container>
    );
  }
}
